import React from 'react'
import './middleWindow.css'
import underConstruction from '../../assets/underConstruction.png'



function MiddleWindow(props) {
    return (props.trigger) ? (
        <div className='outsideMiddleWindow'>
            <div className='middleWindow-Body slide-in-fwd-center'>
                <button className='close-btn' onClick={() => props.setTrigger(false)}>  X  </button>
                <div className='windowTitle'>Under Development</div>
                <div className='middleWindow-Body-image'>
                    <img src={underConstruction} alt="under construction"/>
                </div>
                <p>AdaLink is under development. We submitted a proposal in Catalys F10. Your vote will help bring this platform to life. Check the proposal's details and timeline by clicking below.</p>
                <p><a href="https://www.lidonation.com/en/proposals/adalink-affiliate-network-for-spo-growth-f10" target="_blank" rel="noopener noreferrer">AdaLink's Catalyst F10 Proposal</a></p>
                <button className='windowOKButton' onClick={() => props.setTrigger(false)}>OK</button>
                { props.children }
            </div>
        </div>
    ) : "";
}

export default MiddleWindow;